import { CapoPlugin } from "/app/landing/node_modules/nuxt/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];